/** Frontend helpers for pack ↔ base unit display */

export const getPackSize = (med?: { packSize?: number } | null) =>
  Math.max(1, Math.floor(Number(med?.packSize)) || 1);

export const formatStockAvail = (
  qty: number,
  med?: { packSize?: number; unit?: string; purchaseUnit?: string } | null
) => {
  const unit = med?.unit || "pieces";
  const packSize = getPackSize(med);
  const purchaseUnit = med?.purchaseUnit || "strips";
  if (packSize <= 1) {
    return `${qty} ${unit}`;
  }
  const packs = Math.floor(qty / packSize);
  const loose = qty % packSize;
  if (loose === 0) {
    return `${qty} ${unit} (${packs} ${purchaseUnit})`;
  }
  return `${qty} ${unit} (${packs} ${purchaseUnit} + ${loose})`;
};

export const packDefaultsForCategory = (category?: string) => {
  if (category === "tablet" || category === "capsule") {
    return {
      unit: "pieces",
      purchaseUnit: "strips",
      packSize: 10,
    };
  }
  if (category === "syrup" || category === "injection" || category === "bottles") {
    return {
      unit: "bottles",
      purchaseUnit: "bottles",
      packSize: 1,
    };
  }
  return {
    unit: "pieces",
    purchaseUnit: "pieces",
    packSize: 1,
  };
};
